import { createFileRoute } from "@tanstack/react-router"

import { DropinPanel } from "@/pages/DropinPanel"

export const Route = createFileRoute("/operations/dropin")({
  component: DropinPanel,
})
